import React from 'react'
import { observer } from 'mobx-react-lite'

import { Button, TableCell } from '@material-ui/core'

import { UserSupplyAccountsModal } from '../UserSupplyAccountsModal'

import { useBoolState } from '../../../hooks/commonHooks'

import { MyRowProps } from '../../../types/tableTypes'
import { UserModel } from '../../../server/mpsklad_core/Models/UserModel'

export const AllowAutoSupplyOptionSetting =
  observer(({row}: MyRowProps<UserModel>) => {
    const [isModalOpen, setModalOpen, setModalClosed] = useBoolState()

    const hasSupplyAccounts = row.ozonAccountCount > 0 || row.wbAccountCount > 0 || row.yandexMarketAccountCount > 0

    return (
      <TableCell className="table-border">
        <Button
          size="small"
          color="primary"
          onClick={setModalOpen}
          disabled={!hasSupplyAccounts}
        >
          Открыть
        </Button>

        <UserSupplyAccountsModal
          open={isModalOpen}
          onClose={setModalClosed}
          userId={row.id}
        />
      </TableCell>
    )
  })